import * as E from '@react-email/components';
import { Link } from '@remix-run/react';

export function Logo({ className, variant, to }: { className?: string; variant?: 'v2' | 'v3'; to?: string }) {
  return (
    <Link to={to ?? '/'} className="group grid leading-snug">
      <span className="sr-only">Proven Valor logo</span>
      <LogoImage variant={variant} className={className} />
    </Link>
  );
}

type LogoImageProps = {
  variant?: 'v2' | 'v3';
  className?: string;
  assetUrl?: string;
};

export function LogoImage({ variant, className, assetUrl }: LogoImageProps) {
  return <img src={getImageSrc(variant, assetUrl)} alt="Proven Valor" className={className ?? 'h-28 w-auto'} />;
}

export function EmailLogoImage({ variant, className, assetUrl }: LogoImageProps) {
  return (
    <E.Img alt="Proven Valor" src={getImageSrc(variant, assetUrl)} className={className ?? 'h-full max-h-14 w-auto'} />
  );
}

function getImageSrc(variant: LogoImageProps['variant'], assetUrl?: string) {
  const imagePath = variant === 'v3' ? '/img/logo-v3.png' : '/img/logo-pv.png';
  return assetUrl ? `${assetUrl}${imagePath}` : imagePath;
}
